import { useState } from 'react';
import type { ReactNode } from 'react';
import { FloatingActionsContext, FloatingActionsStore } from './FloatingActionsContext';

interface FloatingActionsProviderProps {
    children: ReactNode;
}

export function FloatingActionsProvider({ children }: FloatingActionsProviderProps) {
    const [store] = useState(() => new FloatingActionsStore());

    return (
        <FloatingActionsContext.Provider value={store}>
            {children}
        </FloatingActionsContext.Provider>
    );
}
